(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gagged-localization"] && !Shopify.designMode) return;
  try {
    (()=>{
    const dialog=document.getElementById('gg-locale-dialog');
    const trigger=document.querySelector('[data-gg-locale-open]');
    const form=document.getElementById('gg-locale-form');
    if(!dialog||!trigger||!form||typeof dialog.showModal!=='function')return;
    const language=document.getElementById('gg-locale-language');
    const country=document.getElementById('gg-locale-country');
    const key='gagged-localization-seen';
    const languages=Array.from(language.options).map(option=>option.value);
    const countryLanguages={PT:'pt-PT',BR:'pt-BR',ES:'es',AR:'es',BO:'es',CL:'es',CO:'es',CR:'es',DO:'es',SV:'es',HN:'es',NI:'es',PY:'es',PE:'es',PR:'es',FR:'fr',GF:'fr',GP:'fr',MQ:'fr',RE:'fr',DE:'de',AT:'de',IT:'it',NL:'nl',GB:'en',AU:'en',NZ:'en',IE:'en'};
    function remember(){try{sessionStorage.setItem(key,'yes')}catch{}}
    trigger.addEventListener('click',()=>dialog.showModal());
    dialog.querySelector('[data-gg-locale-close]').addEventListener('click',()=>{remember();dialog.close()});
    dialog.addEventListener('cancel',remember);
    form.addEventListener('submit',remember);
    // Delivery country and preferred language remain independent.
    let seen=false;try{seen=sessionStorage.getItem(key)==='yes'}catch{}
    if(!seen&&!document.documentElement.classList.contains('shopify-design-mode')){
      const browserLocale=navigator.languages?.[0]||navigator.language||'en';
      const browserLanguage=browserLocale.split('-')[0];
      const suggested=languages.find(code=>code.toLowerCase()===browserLocale.toLowerCase())||languages.find(code=>code.split('-')[0]===browserLanguage);
      if(suggested)language.value=suggested;
      dialog.showModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gagged-reviews"] && !Shopify.designMode) return;
  try {
    (()=>{
    const summaries=document.querySelectorAll('[data-review-summary]');
    summaries.forEach(summary=>{
      const proof=document.querySelector('.gg-buy .gg-social-proof');
      if(!proof)return;
      const count=Number(summary.dataset.reviewCount||0);
      const average=Number(summary.dataset.reviewAverage||0);
      proof.replaceChildren();
      const link=document.createElement('a');
      link.href='#gagged-reviews';
      link.style.color='inherit';
      link.style.textDecoration='none';
      if(count>0){
        const stars=document.createElement('span');
        stars.className='gg-proof-stars';stars.setAttribute('aria-hidden','true');stars.textContent='★★★★★';
        proof.append(stars);
        link.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{maximumFractionDigits:1}).format(average)+'/5 · '+summary.dataset.countLabel.replace('__COUNT__',count);
      }else link.textContent=summary.dataset.emptyLabel;
      proof.append(link);
      const previewNote=document.querySelector('.gg-buy .gg-proof-note');
      if(previewNote)previewNote.hidden=true;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
